<template>
  <div class="home">
    <div class="header">
      <div :class="{'active': btnIndex === index }" @click="haddleClickBtn(index)" v-for="(item, index) in btns" :key="index">{{ item }}</div>
    </div>
    <div class="section">
      <div class="main con1">
        <div style="text-align:center">
          <div class="picture-title-3 con1-text" >
            <p style="">
              快人一步，GET更新潮流娱乐资讯；</br>
              近人一米，零距离领略IDOL风采；</br>
              先人一刻，分享LIVE现场至上快乐。</br>
            </p>
          </div>
          <img class="p-33"  v-lazy="'https://webassets.livelab.com.cn/img/fun.png'" alt="" srcset="">
          <div class="con1-text" style="">
            贴心的演出票务平台，<br/>
            涵盖演唱会、 嘉年华、音乐节、展会等，<br/>
            第一手的演出相关介绍及购票
          </div>
          <div class="icon-group">
            <div class="android">
              <img class="icon-2-1" v-lazy="'https://webassets.livelab.com.cn/img//路径503.png'" alt="" srcset="">
              <span class="ml16" @click="downLoadApp">Android下载</span>
            </div>
            <div class="phone">
              <img class="icon-2-2" v-lazy="'https://webassets.livelab.com.cn/img/icon-2.png'" alt="" srcset="">
              <span class="ml16"  @click="downLoadApp">App store下载</span>
            </div>
          </div>
        </div>
        <div >
          <img class="h-1" src="https://webassets.livelab.com.cn/img/phone-fun.png" />
        </div>
      </div>
      <div class="picture">
        <div>
          <img class="p-1" v-lazy="'https://webassets.livelab.com.cn/img/1-1.png'" />
        <img class="p-2" v-lazy="'https://webassets.livelab.com.cn/img/1-2.png'"/>
        <img class="p-3" v-lazy="'https://webassets.livelab.com.cn/img/1-3.png'"/>
        <img class="p-3" v-lazy="'https://webassets.livelab.com.cn/img/1-3.png'"/>
        </div>
        <div class="p-main main">
          <div class="picture-title-1">
            <div class="">
              <span>一款</span><span class="red">聚焦粉丝服务</span><span>的APP</span>
            </div>
            <div class="picture-title-desc">看得到的看不到的 | 你想看的你不想看的 | 我们都带你看看</div>
          </div>
          <div>

          </div>
          <div class="picture-title-2">

            <div class="">
              <span>让我们一起“没玩<span class="red">没</span>了”</span>
            </div>
            <div class="picture-title-desc">工作要努力，生活要积极，玩乐要嗨皮</div>
          </div>

          <div class="picture-title-4 con1-text">
            <h3>【演出&会员】</h3>
            <p>线下门票，定制周边，粉丝集会</br>先人一步，体验最棒的定制服务</p>
            <h3>【访谈&资讯】</h3>
            <p>专注潮流文化，提供丰富内容与话题。</br>与艺⼈、潮牌主理⼈、潮流大咖⼀同逐浪潮流风潮。</p>
            <h3>【深度专题】</h3>
            <p>深入潮流一线，既是寻人亦是冒险，用态度点亮你的潮流生活。</p>
          </div>

          <div style="position: relative" class="h5-p-box">
            <img class="p-2-1" v-lazy="'https://webassets.livelab.com.cn/img/2-1.png'" />
          <img class="p-2-2" v-lazy="'https://webassets.livelab.com.cn/img/2-2.png'" />
          <img class="p-2-3" v-lazy="'https://webassets.livelab.com.cn/img/2-3.png'" />
          <img class="p-2-4" v-lazy="'https://webassets.livelab.com.cn/img/2-4.png'" />
          <img class="p-2-5" v-lazy="'https://webassets.livelab.com.cn/img/2-5.png'" />
          <img class="p-2-6" v-lazy="'https://webassets.livelab.com.cn/img/2-6.png'" />
          <img class="p-2-7" v-lazy="'https://webassets.livelab.com.cn/img/2-7.png'" />
          <img class="p-2-8" v-lazy="'https://webassets.livelab.com.cn/img/2-8.png'" />
          <img class="p-2-9" v-lazy="'https://webassets.livelab.com.cn/img/2-9.png'" />
          <img class="p-2-10" v-lazy="'https://webassets.livelab.com.cn/img/2-10.png'" />
          </div>
        </div>
      </div>
    </div>
    <div ref='ref1' class="section h5-section" >
      <div class="banner-wap">
        <div class="banner-tt">
          <div class="tt black">门票售卖</div>
          <div class="dd black">时下最热演唱会，提供粉丝专属门票</div>
        </div>
        <img class="banner" v-lazy="'https://webassets.livelab.com.cn/img/3-1.png'" />
      </div>
      <div ref='ref2' class="swiper-wap">
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/4-1.png'" />
        </div>
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/4-2.png'" />
        </div>
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/4-3.png'" />
        </div>
      </div>
    </div>
    <div ref='ref2' class="section">
      <div class="banner-wap">
        <div class="banner-tt">
          <div class="tt">Beyond The Streets</div>
          <div class="dd">聚集当下涂鸦与街头艺术家的盛典，为这些富有才华与创造力的先锋艺术创作者提供了施展才华的舞台</div>
        </div>
        <img class="banner" v-lazy="'https://webassets.livelab.com.cn/img/5-1.png'" />
        <img class="icon-1" v-lazy="'https://webassets.livelab.com.cn/img/icon-1.png'" />
      </div>
      <div class="swiper-wap">
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/5-2.png'" />
        </div>
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/5-3.png'" />
        </div>
        <div class="swiper-list">
          <img class="swiper" v-lazy="'https://webassets.livelab.com.cn/img/5-4.png'" />
        </div>
      </div>
    </div>

    <div ref="ref3" class="section">
      <div class="banner-wap footer-p">
        <img class="banner1" v-lazy="'https://webassets.livelab.com.cn/img/7-1.png'" />
        <img class="icon-3" v-lazy="'https://webassets.livelab.com.cn/img/icon-3.png'" />
        <div class="footer-wap">
          <div class="triangle"></div>
          <div class="footer">
            <img class="logo" v-lazy="'https://webassets.livelab.com.cn/img/fun-1.png'" />
            <div class="LIVELAB2021">纷玩岛 © 2021</div>
            <div class="company">
              <a  :href="src" :target="src">
                <img class="permit" style="width: 30px;height: 30px;" src="@/assets/permit2.png" alt="_target"> 
                沪ICP备2021001687号-1
                <span>｜</span> 
                <a href="https://beian.mps.gov.cn/#/query/webSearch" target="https://beian.mps.gov.cn/#/query/webSearch">
                  <img class="permit" src="@/assets/permit.jpg" alt="_target"> 
                  <span style="margin-left: 5px;">沪公网安备31010902103624</span>
                </a>
                <span>｜</span> 
                上海名辉文化发展有限公司
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
      btns: [
        '首页',
        '演唱会',
        'BTS'
      ],
      scroll: '',
      btnIndex: 0,
      src: 'https://beian.miit.gov.cn/#/Integrated/recordQuery'
      // src:"http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020210210110735000007358758-SAIC_SHOW_310000-20210415160702512880&signData=MEUCIGlaDi3fG1x6LMa2uyhcJiQzjHy8kiuDF4dd7wRRo9wJAiEAzaDnEUsaGmJVUOyG+y1sMYyGagd60fQ8KFbCr6IEAbE="
    }
  },
  mounted() {
    // console.log('====')
    // this.$nextTick(() => {
      window.addEventListener('scroll', this.onScroll,true)
    // })
  },
  destroyed(){
      window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    downLoadApp(){
      this.$router.push({
        name:'downloadApp'
      })
    },
    dataScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    },
    onScroll () {
      const scrolled = document.documentElement.scrollTop || document.body.scrollTop
      if (scrolled >= this.$refs.ref3.offsetTop) {
        this.btnIndex = 3
      } else if (scrolled >= this.$refs.ref2.offsetTop) {
        this.btnIndex = 2
      } else if (scrolled >= this.$refs.ref1.offsetTop) {
        this.btnIndex = 1
      } else {
        this.btnIndex = 0
      }
    },
    haddleClickBtn (index) {
      this.btnIndex = index
      // const jump = document.getElementsByClassName('section')
      // 用 class="instance_title" 添加锚点
      let jump = document.querySelectorAll('.section');
      let total = jump[index].offsetTop;
      let distance = document.documentElement.scrollTop || document.body.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 50;
      if (total > distance) {
          smoothDown();
      } else {
          let newTotal = distance - total;
          step = newTotal / 50;
          smoothUp();
      }
      function smoothDown () {
          if (distance < total) {
              distance += step;
  　　　　　    document.body.scrollTop = distance;
              document.documentElement.scrollTop = distance;
              setTimeout(smoothDown, 10);
          } else {
              document.body.scrollTop = total;
              document.documentElement.scrollTop = total;
          }
      }
      function smoothUp () {
        if (distance > total) {
            distance -= step;
　　　　　　　 document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothUp, 10);
        } else {
            document.body.scrollTop = total;
            document.documentElement.scrollTop = total;
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
 a{text-decoration: none; color: #fff;}
 a:hover, a:visited, a:link, a:active {
   color:#fff;
}
.permit{
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-bottom: 5px;
}
.picture {
  height: 2300px;
  position: relative;
  margin-top: 40px;
}
.picture-title-1 {
  position: absolute;
  left: 10px;
  top: 380px;
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000000;
}
.picture-title-4{
  position: absolute;
  left: 10px;
  top: -130px;
  z-index: 999;
}
.picture-title-2 {
  position: absolute;
  left: 10px;
  top: 1628px;
  font-size: 48px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #000000;
}
.picture-title-desc {
  font-size: 30px;
  color: #000000;
  margin-top: 20px;
}
.red {
  color: #f00;
}
.black {
  color: #000 !important;
}
.banner-wap {
  width: 100%;
  height: auto;
  position: relative;
  .banner-tt {
    position: absolute;
    z-index: 1;
    .tt {
      margin-left: 234px;
      margin-top: 188px;
      font-size: 48px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
    }
    .dd {
      margin-top: 20px;
      margin-left: 234px;
      font-size: 30px;
      font-family: PingFang SC;
      color: #FFFFFF;
    }
  }
  .icon-1 {
    width: 355px;
    height: 222px;
    position: absolute;
    top: 37px;
    right: 0;
  }
  .icon-3 {
    width: 271px;
    height: 303px;
    position: absolute;
    top: 0;
    right: 246px;
  }
}
.p-1 {
  position: absolute;
  top: 180px;
  right: 0;
  width: 388.71px;
  height: 216.66px;
}
.p-2 {
  position: absolute;
  top: 558px;
  left: 0;
  width: 410px;
  height: 232.97px;
}
.p-3 {
  position: absolute;
  top: 1905px;
  left: 0;
  width: 444px;
  height: 278px;
}
.p-main {
  position: relative;
}

.p-2-1 {
  position: absolute;
  left: 0;
  top: 920px;
  width: 514px;
  height: 272px;
}
.p-2-2 {
  position: absolute;
  left: 534px;
  top: 821px;
  width: 272px;
  height: 144px;
}
.p-2-3 {
  position: absolute;
  left: 846px;
  top: 309px;
  width: 272px;
  height: 512px;
}
.p-2-4 {
  position: absolute;
  left: 1158px;
  top: 544px;
  width: 272px;
  height: 512px;
}

.p-2-5 {
  position: absolute;
  left: 534px;
  top: 994px;
  width: 272px;
  height: 512px;
}
.p-2-6 {
  position: absolute;
  left: 851px;
  top: 846px;
  width: 272px;
  height: 512px;
}
.p-2-7 {
  position: absolute;
  left: 1158px;
  top: 1086px;
  width: 272px;
  height: 512px;
}
.p-2-8 {
  position: absolute;
  left: 851px;
  top: 1393px;
  width: 272px;
  height: 512px;
}
.p-2-9 {
  position: absolute;
  left: 846px;
  top: 1935px;
  width: 272px;
  height: 144px;
}
.p-2-10 {
  position: absolute;
  left: 1158px;
  top: 1628px;
  width: 272px;
  height: 512px;
}
.banner {
  width: 100vw;
  min-width: 100%;
  display: block;
  margin-bottom: 80px;
}
.banner1 {
  width: 100vw;
  min-width: 100%;
  display: block;
  margin-bottom: 80px;
}
.swiper-wap {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  .swiper-list {
    width: 512px;
    height: 262px;
    margin-right: 15px;
    margin-left: 15px;
    .swiper {
      width: 512px;
      height: 262px;
      display: block;
    }
    .t {
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #000000;
      text-align: center;
      padding: 28px 0 12px 0;
    }
    .d {
      font-size: 18px;
      font-family: PingFang SC;
      color: #000000;
    }
  }
}
.footer {
  height: 540px;
  background: #000000;
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  .logo {
    width: 111px;
    height: 81px;
    margin-top: 139px;
    margin-bottom: 133px;
  }
  .LIVELAB2021 {
    font-size: 16px;
    font-family: PingFang SC;
    color: #FFFFFF;
  }
  .company {
    margin-top: 42px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
}
.footer-p {
  position: relative;
}
.footer-wap {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.triangle {
  width: 0;
  height: 0;
  border-width: 0 28px 28px;
  border-style: solid;
  border-color: transparent transparent #000;
  margin: 0 auto;
  left: 50%;
  z-index: 1;
  top: -130px;
  // margin-left: -14px;
}
</style>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
}
@mixin center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.h-1 {
  width: 778px;
  height: 648px;
}
.icon-2-2 {
  width: 21px;
  height: 25px;
}
.icon-2-1 {
  width: 21px;
  height: 25px;
}
.p-33 {
  width: 290px;
  height: 192px;
  // margin-left: 60px;
}
.ml16 {
  margin-left: 16px;
}
.header {
  position: fixed;
  z-index: 999999;
  top: 0;
  display: flex;
  align-items: center;
  padding: 0 90px;
  margin-top: 50px;
  div {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-right: 60px;
    cursor: pointer;
  }
  div.active {
    color: #f00;
  }
}
.main {
  width: 1200px;
  margin: 0 auto;
}
.con1 {
  @include center;
  padding-top: 175px;
  .con1-text {
    font-size: 18px;
    font-family: PingFang SC;
    color: #000000;
    // line-height: 35px;
    text-align: center;
  }
}
.icon-group {
  width: 424PX;
  height: 40PX;
  border-radius: 30PX;
  overflow: hidden;
  margin-top: 30px;
  @include center;
  border: 1px solid #666666;
  .android {
    width: 50%;
    font-size: 18px;
    font-family: PingFang SC;
    color: #000;
    opacity: 1;
    @include center;
  }
  .phone {
    position: relative;
    z-index: 1;
    color: #fff;
    width: 50%;
    height: 100%;
    background: #000000;
    border: 1px solid #000000;
    opacity: 1;
    border-radius: 30PX;
    @include center;
  }
}
// @media screen and (max-width: 1000px) {

// }
@media screen and (max-width: 1000px) {
  .con1{
    display: block;
    text-align: center;
  }
  .picture-title-1{
    position: static;
  }
  .picture-title-2{
    position: static;
  }
  .picture-title-4 {
    position: static;
  }
  .h5-p-box{
    margin-top: 90px;
  }
  // -900
  .p-2-1{
    top: 40px;
  }
//   .p-2-1 {
//   top: 920px;
// }
.p-2-2 {
  top: 5px;
}
.p-2-3 {
  top: -97px;
}
.p-2-4 {
  top: -34px;
}
.p-2-5 {
  top: 45px;
}
.p-2-6 {
  top: 20px;
}
.p-2-7 {
  top: 84px;
}
.p-2-8 {
  top: 140px;
}
.p-2-9 {
  top: 260px;
}
.p-2-10 {
  top: 200px;
}
.h5-section{
  margin-top: 180px;
}
  .con1-text {

  }
  .icon-group {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 25PX;
    margin: 20PX 0;
    img {
      width: 16PX;
      height: 16PX;
    }
    .android {
      height: 100%;
      width: 100%;
    }
    .phone {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
